module.exports = __webpack_public_path__ + "img/master-title.f6a5948e.png";